<template>
  <section class="container-fluid mt-3 px-4">
    <Breadcrumb :hideDashboard="true" :back="'/juniper/clients'" />

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <h3 class="mb-0">
          <i class="fas fa-file-pdf text-danger me-2"></i>
          PDF Document Auditor
        </h3>
        <small class="text-muted">Scan and audit PDF documents for ADA/WCAG accessibility compliance</small>
      </div>
    </div>

    <!-- Single PDF Upload Scanner -->
    <PdfScanner class="mb-4" />

    <!-- Per-Client PDF Scanner -->
    <ClientPdfScanner />
  </section>
</template>

<script>
import Breadcrumb from '@/components/juniper/breadcrumb/Breadcrumb.vue'
import PdfScanner from '@/components/juniper/ada-auditor/PdfScanner.vue'
import ClientPdfScanner from '@/components/juniper/ada-auditor/ClientPdfScanner.vue'

export default {
  name: 'PdfAuditor',
  components: {
    Breadcrumb,
    PdfScanner,
    ClientPdfScanner,
  },
}
</script>

<style scoped>
</style>
